import Navbar from "../../../common/layout/Navbar";
import { empType, LicenseTypes, Operation } from "../../../../utils/Enum.types";
import { Title } from "../../../../stories/Title/Title";
import Input from "../../../../stories/Input/Input";
import View from "../../../../images/EyeWhite.svg";

import { useLazyQuery, useMutation } from "@apollo/client";
import { useContext, useEffect, useState } from "react";
import { OrderDirection } from "../../../../utils/commonQueryTypes";
import useUrlParams from "../../../../customHooks/useUrlParams";
import
{
  CustomModal,
  toInputStandardDate,
  toIsoDate,
  toStandardDate
} from "../../../../utils/UtilFunctions";
import { Button } from "../../../../stories/Button/Button";
import
{
  AddModalStyles,
  WaiveOffModalStyles
} from "../../../../styles/CustomModalStyles";
import
{
  AtsMomMasterOrderField,
  DeleteMomMutation,
  DeleteMomMutationVariables,
  GetMomsData,
  GetMomsVars
} from "./queries/types";
import { GetMoms } from "./queries/query";
import AddMeeting from "./AddMeeting";
import { modalOpType, msgType } from "../../../../utils/types";
import
{
  DEFAULT_TIME,
  emptyMessage,
  emptyOpType
} from "../../../../utils/constants";
import { DeleteMom } from "./queries/mutations";
import useLoggedInUserDetails from "../../../../customHooks/useLoggedInUserDetails";
import DeleteModal from "../../../../customComponents/DeleteModal";
import MessageModal from "../../../../customComponents/MessageModal";
import { useNavigate } from "react-router-dom";
import LoadingModal from "../../../pages/LoadingModal";
import { fromToDatesType } from "../../../../utils/formTypes";
import ArrowRight from "../../../../images/ArrowRight.svg";
import { AppContext } from "../../../../context/context";
import Compare from '../../../../images/Compare.svg';
import { Label } from "../../../../stories/Label/Label";
import { TextField } from "@mui/material";

const Meetings = () =>
{
  const { customer_id } = useUrlParams();
  const [ message, setMessage ] = useState<msgType>( emptyMessage );
  const [ deleteModal, setDeleteModal ] = useState( false );
  const [ deleteId, setDeleteId ] = useState( 0 );

  const [ dates, setDates ] = useState<fromToDatesType>( {
    startDate: "",
    endDate: "",
  } );

  const { state } = useContext( AppContext )

  const navigate = useNavigate();

  const { user_details } = useLoggedInUserDetails();
  const [ addMeeting, setAddMeeting ] = useState<modalOpType>( emptyOpType );
  const [ Delete, { loading: updateLoading } ] = useMutation<
    DeleteMomMutation,
    DeleteMomMutationVariables
  >( DeleteMom, {
    onError: ( e ) =>
    {
      setMessage( {
        flag: true,
        message: e.message,
        operation: Operation.NONE
      } );
    }
  } );


  const [ GetMomDetails, { data } ] = useLazyQuery<GetMomsData, GetMomsVars>(
    GetMoms
  );
  useEffect( () =>
  {
    if ( customer_id )
      GetMomDetails( {
        variables: {
          after: null,
          first: 10,
          customerID: customer_id,
          startDate: dates.startDate ? toIsoDate( dates.startDate ) : undefined,
          endDate: dates.endDate ? toIsoDate( dates.endDate ) : undefined,
          orderBy: {
            direction: OrderDirection.DESC,
            field: AtsMomMasterOrderField.MEETING_DATE
          }
        }
      } );
  }, [ GetMomDetails, customer_id, dates.endDate, dates.startDate ] );

  const handleDelete = ( id: number ) =>
  {
    setDeleteModal( false );
    Delete( {
      variables: {
        momID: id,
        user_details
      },
      refetchQueries: [
        {
          query: GetMoms,
          variables: {
            after: null,
            first: 10,
            customerID: customer_id,
            startDate: toIsoDate( DEFAULT_TIME ),
            endDate: toIsoDate( DEFAULT_TIME ),
            orderBy: {
              direction: OrderDirection.ASC,
              field: AtsMomMasterOrderField.MEETING_DATE
            }
          }
        }
      ]
    } ).then( ( { data } ) =>
    {
      if ( data && data.DeleteMom )
      {
        setMessage( {
          flag: true,
          message: "Meeting deleted successfully",
          operation: Operation.DELETE
        } );
      }
    } );
  };
  return (
    <>
      <Navbar NavType={LicenseTypes.DASHBOARD} />
      <Title>Project Minutes of Meeting</Title>
      <div className="meetings">
        <div className="meetings__subtitle">
          <b>Meeting Dates</b>
          <div className="col-4 mq-comparision__filters--flex">
            <TextField
              label="Start Date"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              className="mq-comparision__filters--date"
              type="date"
              value={toInputStandardDate( dates.startDate )}
              onChange={( e ) =>
              {
                const date1 = new Date( e.target.value );
                const date2 = new Date( dates.endDate );
                if ( date1.getTime() < date2.getTime() || dates.endDate === "" )
                {
                  setDates( {
                    ...dates,
                    startDate: e.target.value,
                  } );
                }
                else
                {
                  setMessage( {
                    flag: true,
                    message: "Start Date should be lesser than End Date",
                    operation: Operation.NONE,
                  } )
                }

              }}
            />
            <img
              src={Compare}
              alt=""
              className="mq-comparision__filters--compare"
            />
            <TextField
              label="End Date"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              className="mq-comparision__filters--date"
              type="date"
              value={toInputStandardDate( dates.endDate )}
              onChange={( e ) =>
              {
                const date1 = new Date( dates.startDate );
                const date2 = new Date( e.target.value );

                if ( date1.getTime() < date2.getTime() || dates.startDate === "" )
                {
                  setDates( {
                    ...dates,
                    endDate: e.target.value,
                  } );
                }
                else
                {
                  setMessage( {
                    flag: true,
                    message: "End Date should be greater than Start Date",
                    operation: Operation.NONE,
                  } )
                }
              }}
            />
          </div>
        </div>
        <div className="meetings__block">
          <ul className="meetings__block--cards">
            {data
              ? data.GetMoms.edges.map( ( { node: itm }, index ) =>
              {
                return (
                  <li
                    className="meetings__block--card"
                    onClick={() =>
                    {
                      navigate( `/${ customer_id }/minutesofmeeting/${ itm.id }` );
                    }}
                  >
                    <div className="meetings__block--card-details">
                      <span> <b>{itm.meetingNo}</b></span>
                      <span>{toStandardDate( itm.meetingDate )} </span>
                      {/* <div>
                          <button
                            className="meetings_block--card-details--view"
                            onClick={() => {
                              navigate(
                                `/${customer_id}/minutesofmeeting/${itm.id}`
                              );
                            }}
                          >
                            View
                            <img src={View} alt="" />
                          </button>
                          <button
                            className="meetings_block--card-details--view"
                            onClick={() => {
                              setAddMeeting({
                                flag: true,
                                operation: Operation.UPDATE,
                                id: itm.id,
                              });
                            }}
                          >
                            Update
                          </button>
                          <button
                            className="meetings_block--card-details--view"
                            onClick={() => {
                              setDeleteId(itm.id);
                              setDeleteModal(!deleteModal);
                            }}
                          >
                            Delete
                          </button>
                        </div> */}
                      <img src={ArrowRight} alt="" />
                    </div>
                  </li>
                );
              } )
              : null}
          </ul>
        </div>
        <div className="row g-0">
          < div className="col">
            {state.empSubType === empType.PMU ?
              <Button
                mode="addnew"
                onClick={() =>
                  setAddMeeting( { flag: true, operation: Operation.CREATE } )
                }
              >
                {" "}
                Meeting Date
              </Button> : null}
            <Button
              mode="back"
              onClick={() =>
              {
                navigate( -1 );
              }}
            />
          </div>
        </div>
      </div >

      <CustomModal
        isOpen={addMeeting.flag}
        contentComponent={
          <AddMeeting addMeeting={addMeeting} setModal={setAddMeeting}

            dates={dates}
          />
        }
        style={WaiveOffModalStyles}
        onRequestClose={() => { }}
      />

      <DeleteModal
        id={deleteId}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={handleDelete}
      />

      <LoadingModal flag={updateLoading} />

      <MessageModal
        handleClose={() => setMessage( emptyMessage )}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </>
  );
};

export default Meetings;
